module.exports = __webpack_public_path__ + "img/t-shirt.e9b3319f.jpg";